module.exports = __webpack_public_path__ + "img/cloudy.4954f798.svg";